module.exports = "https://static.wagwalking.com/_next/static/images/michele-king-403be104c6d79ac45b51052ff917c131.png";